export const createSlug = (text) => {
    if (!text) return null;
    
    return text
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
}; 

const createAlias = (eventName, eventId, code=null) => {

    if (eventName && eventName.trim()) {
        const cleanName = createSlug(eventName);
        const uniqueAlias = `${cleanName}-${eventId}${code ? `-${code}` : ''}`;
        console.log('Using event name alias:', uniqueAlias);
        return uniqueAlias; // Event name + affiliate code for uniqueness
    }

    // Fallback: create a more readable format with event ID and affiliate
    const fallbackAlias = `event-${eventId}${code ? `-${code}` : ''}`;
    console.log('Using fallback alias:', fallbackAlias);
    return fallbackAlias;
};

export default createAlias;